<template>
  <div>

      <v-row class="mt-2" justify="center">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <v-card>
            <v-card-text>
               <v-row >
                <v-col xs="12" class="py-0 px-2">
                    <h2>Obračun </h2>
                </v-col>
              </v-row>
              <v-row >
                <v-col xs="12" class="py-0 px-2">
                    <span style="font-weight:bold">{{mainQuery.CompanyNameDatabase}}, {{mainQuery.BusinessYear}}</span>
                </v-col>
              </v-row>

              <v-row >
                <v-col xs="6" >
                  <v-dialog
                    ref="dialog1"
                    persistent
                    v-model="modal1"
                    width="290px"
                    :return-value.sync="startDate"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formatDate1"
                        :label="langC.FromDate"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </template>

                    <v-date-picker v-model="startDate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="modal1 = false">Cancel</v-btn>
                      <v-btn color="primary" @click="$refs.dialog1.save(startDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col xs="6" >
                  <v-dialog
                    ref="dialog2"
                    persistent
                    v-model="modal2"
                    width="290px"
                    :return-value.sync="endDate"
                  >
                  <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formatDate2"
                        :label="langC.ToDate"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </template>

                    <v-date-picker v-model="endDate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="modal2 = false">Cancel</v-btn>
                      <v-btn color="primary" @click="$refs.dialog2.save(endDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>

              <v-row >
                <v-col xs="6" >
                  <v-btn
                    block x-large
                    class="primary mr-3"
                    @click="fillData">
                    {{langC.Analysis}}
                  </v-btn>
                </v-col>
                <v-col xs="6" >
                 
                </v-col>

              </v-row>

              <v-row >
                <v-col xs="6" >
                   <v-alert type="warning" v-model="havealert" dismissible close-text="Close Alert">
                        {{havemssgalert}}
                  </v-alert>
                </v-col>
              </v-row>

              <v-row>
                 <v-col xs="12" >
                   <DocumentPOSTotal v-if="items.length > 0 && Object.keys(period).length !== 0 && period.constructor === Object" :key="toSee" :items="items" :period="period" :totalDiscount="totalDiscount" :totalService="totalService" />
                 </v-col>
              </v-row>


              <v-row >
                <v-col xs="6" >
                  <v-btn block x-large color="gray" @click="doShowItems" class="mt-4 mr-3">
                    Po artiklima
                  </v-btn>
                </v-col>
              </v-row>

              <v-row v-if="showItems">
                 <v-col xs="12">
                   <DocumentPOSTotalItems v-if="itemDetItems.length > 0 && Object.keys(period).length !== 0 && period.constructor === Object" :key="toSee" :items="itemDetItems" :period="period"/>
                 </v-col>
              </v-row>

              <v-row >
                <v-col xs="6" >
                  <v-btn block x-large color="gray" @click="doShowGroups" class="mt-4 mr-3">
                    Po grupama
                  </v-btn>
                </v-col>
              </v-row>

              <v-row v-if="showGrups">
                 <v-col xs="12">
                   <DocumentPOSTotalGroups v-if="itemDet.length > 0 && Object.keys(period).length !== 0 && period.constructor === Object" :key="toSee" :items="itemDet" :period="period"/>
                 </v-col>
              </v-row>


            </v-card-text>
          </v-card>
        </v-col>

            <v-progress-circular v-if="this.saving"
                  indeterminate
                  color="green"
            ></v-progress-circular>
      </v-row>

  </div>


</template>

<script>
import POSService from '@/services/POSService'
import DocumentService from '@/services/DocumentService'
import DocumentDetailService from '@/services/DocumentDetailService'
import DocumentPOSTotal from './DocumentPOSTotal'
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dateFormat from '@/snippets/dateFormat'
import moneyFormat from '@/snippets/moneyFormat'
import dayjs from 'dayjs'
import { wait, dynamicSort } from "@/snippets/allSnippets";
import DocumentPOSTotalGroups from './DocumentPOSTotalGroups'
import DocumentPOSTotalItems from './DocumentPOSTotalItems'

export default {
  name: 'documentposlist',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [],
      itemsLoc: [],
      selectIL: {},
      itemDet: [],
      itemDetItems: [],
      statewhs: false,
      rules: {
        required: value => !!value || '*'
      },
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      date1: null,
      date2: null,
      msg: '',
      comp: {},
      error: null,
      localError: false,
      size: 'sm',
      privitems: [],
      required: (value) => !!value || 'Required.',
      items: [],
      itemDetails: [],
      mainQuery: {
        CompanyId: 1
      },
      Total1: 0,
      Total2: 0,
      Total3: 0,
      Total4: 0,
      Total5: 0,
      Total6: 0,
      Total7: 0,
      Total8: 0,
      Total9: 0,
      PrintDate: null,
      lang: {},
      langC: {},
      saving: false,
      startDate: null,
      endDate: null,
      itemID: '',
      itemName: '',
      havemssgalert: '',
      havealert: false,
      period: {},
      totalDiscount : 0,
      totalService: 0,
      toSee: 1,
      showListTicket: false,
      showGrups: false,
      showItems: false
    }
  },
  async mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
    this.mainQuery.BranchId = this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1

    this.headers.push(
      {text: 'Broj', value: 'documentId', width: '90px', class: "headline"},
      {text: this.lang.documentDate1, value: 'documentDate', width: '50px', class: "headline"},
      {text: this.lang.documentTime, value: 'documentTime', width: '30px', class: "headline"},
      {text: 'Iznos', value: 'documentTotalAmountBrutto', type: 'decimal', width: '80px', align: 'right', class: "headline"},
      {text: this.lang.documentJIR, value: 'documentJIR', width: '250px', class: "headline"},
      {text: this.lang.documentZKI, value: 'documentZKI', width: '250px', class: "headline"},
      {text: this.lang.partnerName, value: 'partnerName', width: '250px', class: "headline"},
    )
    this.$store.dispatch('settypePOSPrint', null)

    this.startDate = dayjs().format('YYYY-MM-DD')
    this.endDate = dayjs().format('YYYY-MM-DD')
    await this.fillData()

  },
  computed: {
    formIsValid () {
      return this.mainQuery.CompanyId !== null
    },
    formatDate1() {
      return this.startDate
        ? dateFormat(this.startDate)
        : "";
    },
    formatDate2() {
      return this.endDate
        ? dateFormat(this.endDate)
        : "";
    },
  },
  methods: {
    doShowListTicket() {
      this.showListTicket = !this.showListTicket
    },
    doShowGroups() {
      this.showGrups = !this.showGroups
    },
    doShowItems() {
      this.showItems = !this.showItems
    },


    async fillData(){
        this.havealert = false
        if (this.startDate) {
          this.mainQuery.fromDate = dayjs(this.startDate).format('YYYY-MM-DD')
        }
        if (this.endDate) {
          this.mainQuery.toDate = dayjs(this.endDate).format('YYYY-MM-DD')
        }
        this.itemDet.length = 0
        this.itemDetItems.length = 0
        this.Total1 = 0
        this.Total2 = 0
        this.Total3 = 0
        this.Total4 = 0
        this.Total5 = 0
        this.Total6 = 0
        this.totalDiscount = 0
        this.totalService = 0
        this.saving = true
        this.items.length = 0
        this.itemDetails.length = 0
        this.itemDet.length = 0
        this.itemDetItems.length = 0
        
        await POSService.choose(this.mainQuery)
        //await DocumentService.documentsalesana(this.mainQuery)
        .then((res) => {
          this.items = res && res.data && res.data.pos && res.data.pos.length > 0 ? res.data.pos : []
          
          if (this.items.length === 0) {
            this.havealert = true
            this.havemssgalert = 'Za period ' + dayjs(this.startDate).format('DD.MM.YYYY') + ' do ' + dayjs(this.endDate).format('DD.MM.YYYY') + ' nema racuna kase.'
          }
        })
        .catch((err) => {
          this.items.length = 0
          this.havealert = true
          this.havemssgalert = 'Za period ' + dayjs(this.startDate).format('DD.MM.YYYY') + ' do ' + dayjs(this.endDate).format('DD.MM.YYYY') + ' nema racuna kase.'
          // eslint-disable-next-line
          console.log(err)
        })

        if (this.items && this.items.length > 0) {
          this.items.map(itm => {
            if (itm.bill) {
              itm.bill.map(bll=> {
                this.itemDetails.push(bll)
              })
              
            }
            if (itm.Stavke) {
              itm.Stavke.map(stv => {
                //const pdvIznos = (stv.IZNOS - stv.PPU_IZNOS) / (1 +(stv.PDVPOSTO/100))
                const pdvIznos = 0
                const newItem = {
                  GroupId: stv.GRUPA ,
                  GroupName: stv.GRUPA ,
                  itemID: stv.SIFART ,
                  itemName: stv.NAZIV ,
                  itemPcsMinus: stv.KOLICINA ,
                  itemFullTotal: stv.IZNOS ,
                  itemVAT1Percentage: stv.PDVPOSTO,
                  itemVAT1Amount: pdvIznos,
                  itemVAT2Percentage: stv.PPU_POSTO,
                  itemVAT2Amount: stv.PPU_IZNOS,
                  itemPriceWithVAT: stv.MPC
                }
                this.itemDetails.push(newItem)
              })
            }
          })

          if (this.itemDetails) {
            this.itemDet = [...this.itemDetails]
            this.itemDet.sort(dynamicSort("itemGroup"))
            this.itemDetItems = [...this.itemDetails]
            this.itemDetItems.sort(dynamicSort("itemID"))
            this.itemDetails.map(item=> {
              this.totalDiscount += parseFloat(item.itemDiscountAmount1)
              if (item.itemService === true) {
                this.totalService += parseFloat(item.itemFullTotal)
              }
            })
          }
        }

        this.period.startDate = this.startDate
        this.period.endDate = this.endDate
        this.saving = false
        this.toSee += 1
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    localDate(dateToFormat) {
      return dateFormat(dateToFormat)
    },
    localTime(timeToFormat) {
      return timeToFormat.substr(0,5)
    },
    returnPOS() {
      this.$store.dispatch('setDocumentActivHead', {})
      this.$store.dispatch('setDocumentActivItems', [])
      this.$router.push({name: 'documentpos'})
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async navigateTo (params) {
      try {

        const dbDocument = await DocumentService.show(params.id)
        if (dbDocument) {
          this.$store.dispatch('setDocumentActivHead', dbDocument.data.document)
        } else {
          this.$store.dispatch('setDocumentActivHead', {})
        }
        this.$store.dispatch('setDocumentid', params.id)
        this.$store.dispatch('setDatabaseDocID', params.id)
        if (this.$store.state.companyid) {
          this.mainQuery.CompanyId = this.$store.state.companyid
        }
        if (this.$store.state.businessYear) {
          this.mainQuery.businessYear = this.$store.state.businessYear
        }
        if (this.$store.state.documentActiv) {
          this.mainQuery.documentName = this.$store.state.documentActiv
        }
        if (this.$store.state.databaseDocID) {
          this.mainQuery.databaseDocID = this.$store.state.databaseDocID
        }
        if (this.$store.state.documentSide) {
          this.docSide = this.$store.state.documentSide
        }
        this.items = (await DocumentDetailService.index(this.mainQuery)).data.documentDetails
        if (this.items) {
          this.$store.dispatch('setDocumentActivItems', this.items)
        } else {
          this.$store.dispatch('setDocumentActivItems', [])
        }
        this.$store.dispatch('setprintSmall', false)
        this.$store.dispatch('setprintNoPrice', false)
        this.$router.push({
          name: 'documentposagain'
        })

      } catch (err) {
        // eslint-disable-next-line
        console.log('error read from database', err)
      }
    },
    close () {
      this.show = false
    },
    async documentlist () {
      try {
        this.havePath = this.$store.state.retPath
        this.$store.dispatch('setretPath', '')
        await this.$router.push({
          name: 'home'
        })
      } catch (err) {
        console.log(err)
      }
    }
  },
  watch: {

  },
  components: {
    DocumentPOSTotal,
    DocumentPOSTotalGroups,
    DocumentPOSTotalItems
  }
}
</script>

<style >

</style>
